export default "__VITE_PUBLIC_ASSET__983542a2__"